import Add from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import ProfileCard from "../../../components/cards/profileCard";
import AppContainer from "../../../components/containers/AppContainer";
import CustomBar from "../../../components/customBar";
import DynamicTable from "../../../components/dynamicTable";
import AppLoader from "../../../components/loader/loader";
import NavigationDrawer from "../../../components/navigationDrawer";
import {
  assingJob,
  getJobDetails,
  getJobDetailsById,
  getJobId,
  unAssingJob,
  updateJobByAdmin,
} from "../../../services/jobs";

const tableHeader = [
  "JOB NAME",
  "REQUIRED PEOPLES",
  "APPOINTMENT DATE",
  "DURATION (DAYS)",
  "TOTAL HOURS(PER DAY)",
  "HOURLY RATE",
  "TOTAL AMOUNT",
];

const displayRows = [
  "name",
  "requiredPeoples",
  "startDate",
  "duration",
  "totalHours",
  "hourlyRate",
  "totalAmount",
];

const JobsDetailForEach = () => {
  const { state } = useLocation();
  const [assignmmentId, setAssignmmentId] = useState("");
  const [inputFields, setInputFields] = useState([]);
  const [detailsData, setDetailsData] = useState(state?.job || []);

  const [isLoading, setIsLoading] = useState(false);
  const [jobDetails, setJobsDetails] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [jobsDetailsById, setJobsDetailsById] = useState([]);

  const [inputValues, setInputValues] = useState(
    () =>
      state?.job?.reduce((acc, job) => {
        acc[job._id] = job?.adminValue || "";
        return acc;
      }, {}) || {}
  );

  function getWorkDuration(checkInTime, checkOutTime) {
    if (!checkInTime) {
      return "Job has not started yet.";
    }

    if (checkInTime && !checkOutTime) {
      return "Worker is currently working...";
    }

    const start = new Date(checkInTime);
    const end = new Date(checkOutTime);
    const diffMs = end - start;

    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours === 0 && minutes < 60) {
      return `${minutes} minute${minutes !== 1 ? "s" : ""}`;
    } else if (minutes === 0) {
      return `${hours} hour${hours > 1 ? "s" : ""}`;
    } else {
      return `${hours} hour${hours > 1 ? "s" : ""} ${minutes} minute${
        minutes !== 1 ? "s" : ""
      }`;
    }
  }

  const handleClose = () => {
    setOpenModal(false);
    setSelectedProfile(null);
  };
  useEffect(() => {
    if (jobDetails.length > 0) {
      let updatedJobs = detailsData.map((job) => {
        let recommendedProfiles = jobDetails.filter(
          (item) => item?.jobTitle?.name === job?.name
        );
        return { ...job, recommendedProfiles };
      });

      setDetailsData(updatedJobs);
    }
  }, [jobDetails]);

  useEffect(() => {
    handdleGetJobDetailsById();
    handleFetchAssingmentId();
  }, []);

  useEffect(() => {
    if (jobsDetailsById?.extraCost?.length) {
      setInputFields(jobsDetailsById.extraCost);
    } else {
      setInputFields([{ text: "", number: "" }]);
    }
  }, [jobsDetailsById]);

  const handleFetchAssingmentId = async () => {
    try {
      setIsLoading(true);
      const response = await getJobId(state?._id);
      if (response.status === 200 || response.status === 201) {
        handleFetchJobDetails(response?.data?.assignmentId);
        setAssignmmentId(response?.data?.assignmentId);
      } else {
        console.log(response.data?.message, "messagemessagemessagemessage");
      }
    } catch (error) {
      console.log("handleFetchAssingmentId ~ error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handdleGetJobDetailsById = async () => {
    try {
      setIsLoading(true);
      const response = await getJobDetailsById(state?._id);
      if (response.status === 200 || response.status === 201) {
        let data = response.data?.data;
        setJobsDetailsById(data);
      } else {
        console.log(response.data?.message, "messagemessagemessagemessage");
      }
    } catch (error) {
      console.log("handleFetchAssingmentId ~ error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFetchJobDetails = async (assignmentId) => {
    try {
      setIsLoading(true);
      const ids = state?.job?.map((item) => item?._id);
      let params = {
        roles: ids,
        assignmentId: assignmentId,
      };

      console.log(params, "paramsparamsparams");

      const response = await getJobDetails(params);
      if (response.status === 200 || response.status === 201) {
        setJobsDetails(response?.data || []);
      } else {
        console.log(response.data?.message, "messagemessagemessagemessage");
      }
    } catch (error) {
      console.log("\ud83d\ude80 ~ handleFetchJobDetails ~ error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeRecommendedAmount = (value, jobId) => {
    setInputValues((prev) => ({
      ...prev,
      [jobId]: value,
    }));

    setDetailsData((prevData) =>
      prevData.map((job) =>
        job._id === jobId ? { ...job, adminValue: value } : job
      )
    );
  };

  const onCancelledAppointment = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to cancelled this appointment?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Accept!",
    });

    if (result?.isConfirmed) {
      try {
        setIsLoading(true);
        const response = await updateJobByAdmin(jobsDetailsById?.jobId, {
          job: detailsData,
          jobStatus: "Cancelled",
        });
        setIsLoading(false);
        if (response.status === 200 || response.status === 201) {
          Swal.fire("Cancelled", "Job Cancelled successfully", "success");
          handdleGetJobDetailsById();
        } else {
          Swal.fire("Error", response?.data?.message, "error");
        }
      } catch (error) {
        setIsLoading(false);
        console.log(error, "errorerrorerror");
      }
    } else {
      Swal.fire("Error", "Some Thing Went Wrrong", "success");
    }
  };

  const onUpdateAppointment = async () => {
    const result = await Swal.fire({
      title: "Are you sure you want to accept this job?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Accept!",
    });

    if (result?.isConfirmed) {
      try {
        setIsLoading(true);
        const response = await updateJobByAdmin(jobsDetailsById?.jobId, {
          job: detailsData,
          jobStatus: "Accepted",
        });
        setIsLoading(false);
        if (response.status === 200 || response.status === 201) {
          Swal.fire("Accepted", "Job accepted successfully", "success");
          handdleGetJobDetailsById();
        } else {
          Swal.fire("Error", response?.data?.message, "error");
        }
      } catch (error) {
        setIsLoading(false);
        console.log(error, "errorerrorerror");
      }
    } else {
      Swal.fire("Error", "Job assignment was cancelled.", "success");
    }
  };

  const onAssingedJob = async (row) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: `Do you want to assign this job to ${
        row?.fullName || row?.name || "this person"
      }?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, assign it!",
    });

    if (result.isConfirmed) {
      try {
        let params = {
          assignmentId: assignmmentId,
          profileId: row?.jobSeekerId?._id,
          role: row?.jobTitle?.name,
        };

        setIsLoading(true);

        const response = await assingJob(params);

        setIsLoading(false);
        if (response.status == 200 || response.status == 201) {
          Swal.fire("Assigned!", response?.data?.message, "success");
          handleFetchAssingmentId();
          handdleGetJobDetailsById();
        } else {
          Swal.fire("Error!", response?.data?.message, "error");
        }
      } catch (error) {
        setIsLoading(false);
        console.log("🚀 ~ onAssingedJob ~ error:", error);
        Swal.fire(
          "Error!",
          "Something went wrong while assigning the job.",
          "error"
        );
      }
    }
  };

  const onUnAssingedJob = async (row) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: `Do you want to unassign this job to ${
        row?.fullName || row?.name || "this person"
      }?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, un-assign it!",
    });

    if (result.isConfirmed) {
      try {
        let params = {
          assignmentId: assignmmentId,
          profileId: row?.jobSeekerId?._id,
          role: row?.jobTitle?.name,
        };

        setIsLoading(true);

        const response = await unAssingJob(params);

        setIsLoading(false);
        if (response.status == 200 || response.status == 201) {
          Swal.fire("UnAssigned!", response?.data?.message, "success");
          handleFetchAssingmentId();
          handdleGetJobDetailsById();
        } else {
          Swal.fire("Error!", response?.data?.message, "error");
        }
      } catch (error) {
        setIsLoading(false);
        console.log("🚀 ~ onunAssingedJob ~ error:", error);
        Swal.fire(
          "Error!",
          "Something went wrong while un-assigning the job.",
          "error"
        );
      }
    }
  };

  const onAttendancePress = (row) => {
    setSelectedProfile(row);
    setOpenModal(true);
  };

  const handleAddFields = () => {
    setInputFields([...inputFields, { text: "", number: "" }]);
  };

  const handleRemoveField = (index) => {
    const updatedFields = inputFields.filter((_, i) => i !== index);
    setInputFields(updatedFields);
  };

  const handleChange = (index, key, value) => {
    const updatedFields = [...inputFields];
    updatedFields[index][key] = value;
    setInputFields(updatedFields);
  };

  const handleSubmit = async () => {
    const result = await Swal.fire({
      title: "Are you sure you want to add additional charges?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Submit!",
    });

    if (result?.isConfirmed) {
      const cleanedData = inputFields
        .filter((item) => item.text.trim() && item.number !== "")
        .map((item) => ({
          text: item.text.trim(),
          number: Number(item.number),
        }));
      const total = cleanedData?.reduce((sum, item) => sum + item.number, 0);
      let totalCost = total + jobsDetailsById?.totalCost;

      try {
        setIsLoading(true);
        const response = await updateJobByAdmin(jobsDetailsById?.jobId, {
          extraCost: cleanedData,
          totalCost: totalCost,
          jobStatus: "In Progress",
        });
        setIsLoading(false);

        if (response.status === 200 || response.status === 201) {
          Swal.fire(
            "Submitted!",
            "Extra charges have been updated successfully.",
            "success"
          );
          handdleGetJobDetailsById();
        } else {
          Swal.fire(
            "Error",
            response?.data?.message || "Something went wrong",
            "error"
          );
        }
      } catch (error) {
        setIsLoading(false);
        console.error(error);
        Swal.fire(
          "Error",
          "An unexpected error occurred while submitting.",
          "error"
        );
      }
    } else {
      Swal.fire("Cancelled", "Submission has been cancelled.", "info");
    }
  };

  return (
    <NavigationDrawer>
      <CustomBar title="JOBS DETAILS" />
      {detailsData.map((job) => {
        const startDate = new Date(job.startDate);
        const endDate = new Date(job.endDate);

        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);

        const duration = (endDate - startDate) / (1000 * 60 * 60 * 24) + 1;

        const totalAmount = job.totalHours * job.hourlyRate * duration;

        return (
          <AppContainer key={job._id} styleProps={{ mt: 4 }}>
            <Stack>
              <DynamicTable
                tableHeader={tableHeader}
                recommendedAmmount={inputValues}
                displayRows={displayRows}
                handleChangeRecommendedAmount={handleChangeRecommendedAmount}
                tableData={[{ ...job, duration, totalAmount }]}
              />
            </Stack>

            <Box mt={4} sx={{ p: 2 }}>
              <Typography variant="h6" fontWeight="bold" mb={2}>
                {job.name} Job Seekers
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  justifyContent:
                    !job?.recommendedProfiles?.length > 0 && "center",
                  overflowX: "auto",
                  p: 1,
                  scrollbarWidth: "thin",
                  "&::-webkit-scrollbar": { height: 6 },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#888",
                    borderRadius: 3,
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#555",
                  },
                }}
              >
                {job?.recommendedProfiles?.length > 0 ? (
                  <>
                    {job?.recommendedProfiles?.map((profile) => (
                      <ProfileCard
                        job={state}
                        user={profile}
                        onAssingedJob={() => onAssingedJob(profile)}
                        onUnAssingedJob={() => onUnAssingedJob(profile)}
                        onAttendancePress={() => onAttendancePress(profile)}
                      />
                    ))}
                  </>
                ) : (
                  <Typography color="#000" textAlign={"center"}>
                    No Profiles Found!
                  </Typography>
                )}
              </Box>
            </Box>
          </AppContainer>
        );
      })}

      <AppContainer styleProps={{ mt: 4 }}>
        <Box sx={{ p: 3 }}>
          <Stack direction={"row"} alignItems={"center"} mb={2}>
            <Typography variant="h6" fontWeight="bold">
              Add Extra Cost
            </Typography>
            <Button
              disabled={
                state?.jobStatus == "Cancelled" ||
                state?.jobStatus == "Completed"
              }
              variant="contained"
              sx={{ width: 100, ml: 2 }}
              startIcon={<Add />}
              color="primary"
              onClick={handleAddFields}
            >
              Add
            </Button>
          </Stack>

          {inputFields.map((input, index) => (
            <Stack
              key={index}
              direction="row"
              spacing={2}
              alignItems="center"
              mb={2}
            >
              <TextField
                label="Text"
                value={input.text}
                onChange={(e) => handleChange(index, "text", e.target.value)}
                fullWidth
              />
              <TextField
                label="Amount"
                type="number"
                value={input.number}
                onChange={(e) => handleChange(index, "number", e.target.value)}
                fullWidth
              />
              <IconButton
                color="error"
                onClick={() => handleRemoveField(index)}
                disabled={
                  inputFields.length === 1 ||
                  jobsDetailsById?.jobStatus == "Completed" ||
                  jobsDetailsById?.jobStatus == "Cancelled"
                }
              >
                <DeleteIcon />
              </IconButton>
            </Stack>
          ))}

          {jobsDetailsById?.paymentStatus !== "Paid" &&
            jobsDetailsById?.jobStatus !== "Accepted" && (
              <Stack
                direction="row"
                justifyContent={"flex-end"}
                spacing={2}
                mt={2}
              >
                <Button
                  disabled={state?.jobStatus == "Cancelled"}
                  sx={{ width: 100 }}
                  variant="contained"
                  color="success"
                  onClick={handleSubmit}
                >
                  Update
                </Button>
              </Stack>
            )}
        </Box>
      </AppContainer>
      <Stack direction={"row"} alignItems={"center"} sx={{ mt: 4 }}>
        <Box>
          <Button
            disabled={
              jobsDetailsById?.jobStatus == "Completed" ||
              jobsDetailsById?.jobStatus == "Cancelled"
            }
            variant="contained"
            onClick={onUpdateAppointment}
          >
            {jobsDetailsById?.jobStatus == "Accepted" ||
            jobsDetailsById?.jobStatus == "Completed"
              ? "Update"
              : "Accept"}
          </Button>
        </Box>
        {jobsDetailsById?.jobStatus == "Accepted" && (
          <Box ml={2}>
            <Button
              disabled={jobsDetailsById?.jobStatus == "Completed"}
              variant="contained"
              onClick={onCancelledAppointment}
            >
              Cancel Job
            </Button>
          </Box>
        )}
      </Stack>
      <AppLoader isVisible={isLoading} />
      <Modal open={openModal} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 700,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" mb={2}>
            Attendance of {selectedProfile?.jobSeekerId?.firstname || "User"}
          </Typography>

          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Check In</TableCell>
                  <TableCell>Check Out</TableCell>
                  <TableCell>Hours/Day</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedProfile?.checkInOut?.length == 0 && (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      No Attendance Found!
                    </TableCell>
                  </TableRow>
                )}
                {selectedProfile?.checkInOut?.length > 0 &&
                  selectedProfile?.checkInOut?.map((att, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        {moment(att?.date).format("DD/MM/YYYY")}
                      </TableCell>
                      <TableCell>
                        {(att?.checkInTime &&
                          moment(att?.checkInTime).format("hh:mm A")) ||
                          "-"}
                      </TableCell>
                      <TableCell>
                        {(att?.checkOutTime &&
                          moment(att?.checkOutTime).format("hh:mm A")) ||
                          "-"}
                      </TableCell>
                      <TableCell>
                        {getWorkDuration(
                          att?.checkInTime || null,
                          att?.checkOutTime || null
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>
    </NavigationDrawer>
  );
};

export default JobsDetailForEach;
